export default {
  api_r_user_module_dynamicForm_getModuleData: {
    path: 'm/dynamic-form/get-module-data/',
  },
  api_r_user_module_dynamicForm_getPermissions: {
    path: 'm/dynamic-form/get-permissions/',
  },
  api_r_user_module_dynamicForm_home: {
    path: 'm/dynamic-form/home/',
  },
  api_r_user_module_dynamicForm_step_get: {
    path: 'm/dynamic-form/step/get/',
  },
  api_r_user_module_dynamicForm_step_edit: {
    path: 'm/dynamic-form/step/edit/',
  },
  api_r_user_module_dynamicForm_add: {
    path: 'm/dynamic-form/add/',
  },
  api_r_user_module_dynamicForm_continue: {
    path: 'm/dynamic-form/continue/',
  },
  api_r_user_module_dynamicForm_back: {
    path: 'm/dynamic-form/back/',
  },
  api_r_user_module_dynamicForm_end: {
    path: 'm/dynamic-form/end/',
  },
  api_r_user_module_dynamicForm_endConfirm_get: {
    path: 'm/dynamic-form/end-confirm/get/',
  },
  api_r_user_module_dynamicForm_endConfirm_edit: {
    path: 'm/dynamic-form/end-confirm/edit/',
  },
  api_r_user_module_dynamicForm_lawFile_get: {
    path: 'm/dynamic-form/law-file/get/',
  },
};
